/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
} from './Asset';

/**
 * 
 * @export
 * @interface AssetPage
 */
export interface AssetPage {
    /**
     * 
     * @type {Array<Asset>}
     * @memberof AssetPage
     */
    assets: Array<Asset>;
    /**
     * 
     * @type {number}
     * @memberof AssetPage
     */
    totalNr: number;
    /**
     * 
     * @type {string}
     * @memberof AssetPage
     */
    asOfDate: string;
}

/**
 * Check if a given object implements the AssetPage interface.
 */
export function instanceOfAssetPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assets" in value;
    isInstance = isInstance && "totalNr" in value;
    isInstance = isInstance && "asOfDate" in value;

    return isInstance;
}

export function AssetPageFromJSON(json: any): AssetPage {
    return AssetPageFromJSONTyped(json, false);
}

export function AssetPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets': ((json['assets'] as Array<any>).map(AssetFromJSON)),
        'totalNr': json['total_nr'],
        'asOfDate': json['as_of_date'],
    };
}

export function AssetPageToJSON(value?: AssetPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets': ((value.assets as Array<any>).map(AssetToJSON)),
        'total_nr': value.totalNr,
        'as_of_date': value.asOfDate,
    };
}

